export const ADD_TO_CART = "ADD_TO_CART";
export const INCREASE_QUANTITY = "INCREASE_QUANTITY";
export const DECREASE_QUANTITY = "DECREASE_QUANTITY";
export const REMOVE_QUANTITY = "REMOVE_QUANTITY";
export const CLEAR_QUANTITY = "CLEAR_QUANTITY";
